import { render, staticRenderFns } from "./CostPricesUnitForm.vue?vue&type=template&id=1c10870c&scoped=true"
import script from "./CostPricesUnitForm.vue?vue&type=script&lang=js"
export * from "./CostPricesUnitForm.vue?vue&type=script&lang=js"
import style0 from "./CostPricesUnitForm.vue?vue&type=style&index=0&id=1c10870c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10870c",
  null
  
)

export default component.exports